import { memo } from 'react';
import type { MediaItem } from '../types';
import { MEDIA_TILE_GAP } from '../constants';
import { MediaTile } from './MediaTile';

type MediaTileRowProps = {
  items: MediaItem[];
  tilesPerRow: number;
  onTileClick: (id: string) => void;
};

export const MediaTileRow = memo(({ items, tilesPerRow, onTileClick }: MediaTileRowProps) => (
  <div className="grid pb-2" style={{ gridTemplateColumns: `repeat(${tilesPerRow}, 1fr)`, gap: MEDIA_TILE_GAP }}>
    {items.map((item) => (
      <MediaTile key={item.id} item={item} onClick={() => onTileClick(item.id)} />
    ))}
  </div>
));
